import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export async function getActivityLogs(params) {
  try {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.get(`${API_BASE}/api/activity-logs`, {
      params,
      headers
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch activity logs');
  }
}
export async function downloadActivityLogPdf(params) {
  try {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
    const headers = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.get(`${API_BASE}/api/activity-logs/download-pdf`, {
      params,
      headers,
      responseType: 'blob', // Important for handling PDF files
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to download activity log PDF');
  }
}
